import { IResourceFilesProvider, ResourceProviderLocation } from 'app/interfaces/IResourceFilesProvider';
import { FileClientProviderService } from './file-client-provider.service';
import { LoggerService } from 'app/logger/logger.service';
import { BaseFileResourceProviderService } from 'app/services/resource-providers/base-file-resource-provider';
import { PrimaryResourceUrlInformationService } from 'app/services/primary-resource-url-information.service';
import { IdentityService } from 'app/model/services/identity.service';
import { IResourceContext } from 'app/multi-contexts/resource-context.typings';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';

export class LocalResourceProviderService extends BaseFileResourceProviderService implements IResourceFilesProvider {
    protected static readonly className: string = 'LocalResourceProviderService';

    constructor(
        _contextData: IResourceContext,
        _loggerService: LoggerService,
        _fileClientProviderService: FileClientProviderService,
        _primaryResourceUrlService: PrimaryResourceUrlInformationService,
        _identityService: IdentityService,
        _exposureControlService: ExposureControlService
    ) {
        super(
            _contextData,
            _fileClientProviderService,
            _loggerService,
            _identityService,
            _exposureControlService,
            undefined,
            _primaryResourceUrlService,
            ResourceProviderLocation.Local
        );
    }

    protected async getLatestVersionId(): Promise<string> {
        return 'xxxxxxxxxx';
    }
}
